import { createSagaActionTypes } from '../../../utils/actionFactory';

export const SET_INITIAL_VALUE = 'SET_INITIAL_VALUE';

export const actions = createSagaActionTypes('SELECT_CLIENT', [
  SET_INITIAL_VALUE
]);
